import { EventDrivenStore } from '@core/store';
import constants from './constants';

class CheckoutStore extends EventDrivenStore {
  constructor() {
    super('checkout', {
      currentStep: 1,
      ticket: null,
      order: {
        ticketId: null,
        quantity: 1,
        attendees: [],
        payment: {},
        promoCode: null
      },
      orderSummary: null,
      paymentMethods: [],
      loading: false,
      error: null
    }, {
      useLocalStorage: false // Don't persist checkout
    });
  }

  setupEvents() {
    // Start checkout
    this.on(constants.EVENTS.CHECKOUT.START, (ticket) => {
      this.updateState({
        ticket,
        currentStep: 1,
        order: {
          ...this.state.order,
          ticketId: ticket.id,
          quantity: ticket.quantity || 1
        },
        error: null
      });
    });

    // Step changed
    this.on(constants.EVENTS.CHECKOUT.STEP_CHANGED, (step) => {
      this.updateState({ currentStep: step });
    });

    // Payment processing started
    this.on(constants.EVENTS.CHECKOUT.PROCESS_PAYMENT, () => {
      this.updateState({ loading: true, error: null });
    });

    // Payment success
    this.on(constants.EVENTS.CHECKOUT.PROCESS_PAYMENT_SUCCESS, () => {
      this.updateState({ loading: false });
    });

    // Payment error
    this.on(constants.EVENTS.CHECKOUT.PROCESS_PAYMENT_ERROR, (error) => {
      this.updateState({ loading: false });
    });

    // Create order success
    this.on(constants.EVENTS.CHECKOUT.CREATE_ORDER_SUCCESS, (orderSummary) => {
      this.updateState({
        orderSummary,
        currentStep: 4,
        loading: false
      });
    });

    // Create order error
    this.on(constants.EVENTS.CHECKOUT.CREATE_ORDER_ERROR, () => {
      this.updateState({ loading: false });
    });

    // Validation error
    this.on(constants.EVENTS.CHECKOUT.VALIDATION_ERROR, (error) => {
      this.updateState({ error, loading: false });
    });

    // Promo code applied
    this.on(constants.EVENTS.CHECKOUT.APPLY_PROMO_SUCCESS, (discount) => {
      const order = { ...this.state.order };
      order.promoCode = discount;
      this.updateState({ order });
    });

    // Promo code removed
    this.on(constants.EVENTS.CHECKOUT.REMOVE_PROMO, () => {
      const order = { ...this.state.order };
      order.promoCode = null;
      this.updateState({ order });
    });

    // Payment methods loaded
    this.on(constants.EVENTS.CHECKOUT.PAYMENT_METHODS_LOADED, (methods) => {
      this.updateState({ paymentMethods: methods });
    });
  }
}

export default CheckoutStore;
